import { useQuery } from '@apollo/client';
import { GET_INFLUENCER } from '../../api/graphql/query';
import auth from '../../components/auth';

export const useCustomizations = (influencerId?: string | null) => {
  const givenInfluencerId = influencerId
    ? parseInt(influencerId)
    : auth.getUser()?.influencerId ?? null;

  const { data, loading } = useQuery(GET_INFLUENCER, {
    variables: { id: givenInfluencerId },
    skip: !givenInfluencerId,
  });

  return {
    isLoading: loading,
    customizations: data
      ? data.creator?.customizations
      : {
          isNewVideo: false,
          isVideoLibraryEnabled: false,
          isLiveStreamEnabled: false,
          canUsePromotionDetails: false,
          canUsePromotions: false,
        },
  };
};
